import { render, staticRenderFns } from "./YAH.vue?vue&type=template&id=fb9ba1a4&scoped=true"
import script from "./YAH.vue?vue&type=script&lang=js"
export * from "./YAH.vue?vue&type=script&lang=js"
import style0 from "./YAH.vue?vue&type=style&index=0&id=fb9ba1a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9ba1a4",
  null
  
)

export default component.exports